import { render, staticRenderFns } from "./ListViewWatercraftType.vue?vue&type=template&id=4dd78c96"
import script from "./ListViewWatercraftType.vue?vue&type=script&lang=ts"
export * from "./ListViewWatercraftType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports